export default "__VITE_ASSET__BraQczD2__"